// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1Iwpp","text":"SelectPayment_text__3vsL3","title":"SelectPayment_title__46LJs","btn":"SelectPayment_btn__2yakd"};